import { makeIntervalISODate } from '@epicuro-next/utilities';
import { createSelector } from '@ngrx/store';

import { DeliveryPeriodType } from '../../models';
import { selectCurrentShopCurrentDeliveryPeriodType } from '../config-strip.selectors';

import {
  selectBulkDeliveryPeriods,
  selectHasBulkDeliveryPeriods,
  selectHasNoBulkDeliveryPeriods,
  selectSelectedBulkDeliveryPeriod,
} from './bulk-delivery-periods.selectors';
import {
  selectFutureDeliveryPeriods,
  selectHasFutureDeliveryPeriods,
  selectHasNoFutureDeliveryPeriods,
  selectSelectedFutureDeliveryPeriod,
} from './future-delivery-periods.selectors';

export const selectIsFutureCurrentType = createSelector(
  selectCurrentShopCurrentDeliveryPeriodType,
  (currentDeliveryPeriodType) =>
    currentDeliveryPeriodType === DeliveryPeriodType.Future,
);

export const selectIsBulkCurrentType = createSelector(
  selectCurrentShopCurrentDeliveryPeriodType,
  (currentDeliveryPeriodType) =>
    currentDeliveryPeriodType === DeliveryPeriodType.Bulk,
);

export const selectIsNotNowCurrentType = createSelector(
  selectCurrentShopCurrentDeliveryPeriodType,
  (currentDeliveryPeriodType) =>
    currentDeliveryPeriodType !== DeliveryPeriodType.Now,
);

export const selectIsNotAbleSelectAnyPeriods = createSelector(
  selectIsNotNowCurrentType,
  selectHasNoBulkDeliveryPeriods,
  selectHasNoFutureDeliveryPeriods,
  (isNotNow, noBulks, noFutures) => isNotNow && noBulks && noFutures,
);

export const selectShouldSelectBulk = createSelector(
  selectIsFutureCurrentType,
  selectHasNoFutureDeliveryPeriods,
  selectHasBulkDeliveryPeriods,
  (isFutureType, noFuturePeriods, hasBulks) =>
    isFutureType && noFuturePeriods && hasBulks,
);

export const selectShouldSelectFuture = createSelector(
  selectIsBulkCurrentType,
  selectHasNoBulkDeliveryPeriods,
  selectHasFutureDeliveryPeriods,
  (isBulkType, noBulks, hasFuturePeriods) =>
    isBulkType && noBulks && hasFuturePeriods,
);

export const selectBulkAndFuture = createSelector(
  selectBulkDeliveryPeriods,
  selectFutureDeliveryPeriods,
  (bulk, future) => [
    ...bulk.map(({ from, to }) => makeIntervalISODate(from, to)),
    ...future,
  ],
);

export const selectSelectedDeliveryPeriod = createSelector(
  selectSelectedBulkDeliveryPeriod,
  selectSelectedFutureDeliveryPeriod,
  (selectedBulk, selectedFuture) => {
    return selectedBulk
      ? makeIntervalISODate(selectedBulk.from, selectedBulk.to)
      : selectedFuture;
  },
);
